import { z } from "zod";

export const SelectorProductSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    title: z.string(),
    clientId: z.string().optional(),
    productLine: z
        .object({
            "@id": z.string(),
            id: z.number(),
            name: z.string(),
        })
        .optional(),
    brand: z
        .object({
            "@id": z.string(),
            id: z.number(),
            name: z.string(),
        })
        .optional(),
    canModify: z.boolean(),
    canDelete: z.boolean(),
});

export type SelectorProduct = z.infer<typeof SelectorProductSchema>;

type ProductLabelSource = Pick<SelectorProduct, "title" | "brand" | "productLine">;

export const formatProductLabel = (product: ProductLabelSource): string => {
    let name = product.title;
    if (product.brand) {
        name += ` - ${product.brand.name}`;
    }
    if (product.productLine) {
        name += ` (${product.productLine.name})`;
    }
    return name;
};
